import { Auth } from '@aws-amplify/auth';
import { interceptor } from '@mobile-dev/platform/common/api/Interceptor';
import { clearError } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import { loadsAction } from '@mobile-dev/platform/common/redux/actions/LoadsAction';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppConstatnt } from '../../../../Utils/AppConstant';
import { browserDetect, getApplicationFlow, getCarrierEnteredMobileNumber, getValueLocalStorage, setControlNumber, setValueLocalStorage } from '../../../../Utils/Utility';
import ErrornDialog from '../../../Common/ErrorDialog/ErrorDialog';
import Loader from '../../../Common/Loader';
import Billed from '../Billed/Billed';
import Completed from '../Completed/Completed';
import Unbilled from '../UnBilled/Unbilled';
import LoadStatusHeader from './LoadStatusHeader';
import LoadStatusNavBar from './LoadStatusNavBar';
import { paymentMethodTracking } from '@mobile-dev/platform/common/redux/actions/PaymentMethodTracking';


function LoadStatus(props) {

    const dispatch = useDispatch();
    const user = useSelector(state => state.amplifyUser.user);
    const [order, setOrder] = useState(1);
    const billedPo = useSelector(state => state.billed.billedPo);
    const unbilledPo = useSelector(state => state.unbilled.unbilledPo);
    const completedPo = useSelector(state => state.completed.completedPo);
    const loading = useSelector(state => state.loadsStatus.loading);
    const errorStatus = useSelector(state => state.loadsStatus.error);
    const toastId = useRef(null);
    const [billedloads, setBilledLoads] = useState(billedPo?.loads.length);
    const [unbilledloads, setUnbilledLoads] = useState(unbilledPo?.loads.length);
    const [completedloads, setCompletedLoads] = useState(completedPo?.loads.length);

    useEffect(() => {
        dispatch(clearError());
        setControlNumber('')
    }, []);

    useEffect(async () => {
        const token = (await Auth.currentSession()).getIdToken().getJwtToken();
        if (user && token) {
            interceptor(token);
            let phone;
            if (getApplicationFlow() === AppConstatnt.flow.DRIVER) {
                phone = user?.attributes?.phone_number;
            }
            else {
                phone = getCarrierEnteredMobileNumber();

            }
            dispatch(loadsAction(phone));
            if (!getValueLocalStorage('browserName')) {
                const browserName = browserDetect();
                setValueLocalStorage('browserName', browserName)
                dispatch(paymentMethodTracking({
                    browser: browserName,
                    device: '',
                    os: 'web'
                }))
            }

        }

    }, [user]);

    useEffect(() => {
        setCompletedLoads(completedPo?.loads.length);
    }, [completedPo]);

    useEffect(() => {
        setBilledLoads(billedPo?.loads.length);
    }, [billedPo]);

    useEffect(() => {
        setUnbilledLoads(unbilledPo?.loads.length);
    }, [unbilledPo]);



    if (errorStatus) {
        if (errorStatus?.response?.status !== 404) {
            return <ErrornDialog
                error={errorStatus?.response?.data ? errorStatus?.response?.data : errorStatus?.message}
                open
            />
        }
    } else {
        if (!billedPo || !unbilledPo || !completedPo) {
            return <Loader />
        }
    }

    // const billedloads = billedPo?.loads.length;
    // const unbilledloads = unbilledPo?.loads.length;
    // const completedloads = completedPo?.loads.length;

    function clickedComponentOrder(val) {

        setOrder(val);
    }

    return (

        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <LoadStatusHeader />
                    <div className="container_block">
                        <div className="row">
                            <div className="col-md-12">
                                <LoadStatusNavBar
                                    clickedComponentOrder={clickedComponentOrder}
                                    billedLoadsCount={billedloads}
                                    unbilledLoadsCount={unbilledloads}
                                    completedLoadsCount={completedloads}

                                />
                                <div className="tab-content" id="View-manageContestsContent">

                                    {order === 1 && <Unbilled order={order} user={user} />}
                                    {order === 2 && <Billed order={order} user={user} />}
                                    {order === 3 && <Completed order={order} user={user} />}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default LoadStatus;
// export default injectIntl(LoadStatus)